<!--
  功能：T0记录/信号池 (自选股/持仓股)
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="hedgingRecord">
    <div class="record-title">
      <div class="record-title-left">
        <span class="record-title-left-text">T0信号记录</span>
      </div>
      <div class="record-title-right"></div>
    </div>
    <!-- 切换 -->
    <!-- <div class="record-tabs">
      <div class="tabs-info">
        <van-tabs
          v-model="active"
          color="#286df7"
          line-width="16px"
          class="record-tabs-info"
          :background="$route.query.themeStyleVs == '2' ? '#181a23' : 'white'"
          :title-active-color="$route.query.themeStyleVs == '2' ? '#3b85fe' : '#286df7'"
          :title-inactive-color="$route.query.themeStyleVs == '2' ? '#aab9d1' : '#4e5969'"
        >
          <van-tab title="T0信号记录"></van-tab>
          <van-tab title="信号池"></van-tab>
        </van-tabs>
      </div>
      <div class="but-info">
        <van-button
          round
          icon="plus"
          type="info"
          size="mini"
          class="but-info-text"
          v-if="activeInfo == 1"
          @click="gotoCcgUrl()"
          >添加持仓股</van-button
        >
      </div>
    </div> -->
    <!-- 内容部分 -->
    <div class="record-content">
      <!-- T0信号记录 -->
      <div v-if="active == 0">
        <div v-if="triggerStatus == 1">
          <!-- 表头 -->
          <div class="table-header-t0">
            <van-row>
              <van-col :span="6">
                <div class="item-text">股票/T+0收益</div>
              </van-col>
              <van-col :span="12">
                <div class="item-text">调整时间/理由</div>
              </van-col>
              <van-col :span="6">
                <div class="item-text item-text-right">调整价</div>
              </van-col>
            </van-row>
          </div>
          <!-- 数据列表 -->
          <div v-if="displayList.length > 0" class="data-list">
            <van-row class="table-item-t0" v-for="(item, index) in displayList" :key="index">
              <van-col :span="6">
                <div class="item-t0-left">
                  <div class="item-t0-stock-name" @click="gotoStock(item.code)">
                    {{ item.name }}
                  </div>
                  <div class="item-t0-stock-zf" :class="judgeColor(item.t0Rate)">
                    {{ toFixedNum(item.t0Rate, 2, '%') }}
                  </div>
                </div>
              </van-col>
              <van-col :span="18">
                <div v-if=" compareVersions(version,'10.09') && item.hidden == 1" class="item-t0-right">
                  <div class="item-t0-list" v-for="value in item.signals">
                    <div class="item-t0-list-item">
                      <div class="item-t0-time">****</div>
                      <div class="item-t0-price" >****</div>
                    </div>
                    <div class="item-t0-list-item">
                      <div class="item-t0-desc">************</div>
                      <div class="item-t0-view">
                        **** <van-icon name="arrow" font-size="10px"></van-icon>
                      </div>
                    </div>
                  </div>
                  <!-- 解锁按钮 -->
                  <div class="item-t0-unlock" @click="gotoShopUrl(item, index)">解锁信号</div>
                </div>
                <div v-else class="item-t0-right">
                  <div class="item-t0-list" v-for="value in item.signals">
                    <div class="item-t0-list-item">
                      <div class="item-t0-time">
                        <span>
                          {{ formatDateToStr(value.date, '-') }}
                          {{ value.qtime ? value.qtime :  formatTimeToStr(value.time, true) }}</span
                        >
                        <span v-if="value.type == 1" class="item-t0-yjtag">预警</span>
                        <span v-if="value.type == 3" class="item-t0-httag">调回</span>
                      </div>
                      <div class="item-t0-price" >{{ toFixedNum(value.price, 2, '元') }}</div>
                    </div>
                    <div class="item-t0-list-item">
                      <div class="item-t0-desc">{{ value.reason }}</div>
                      <div class="item-t0-view" @click="showReason(item, value)">
                        查看 <van-icon name="arrow" font-size="10px"></van-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </van-col>
            </van-row>
            <!-- 加载更多按钮 -->
            <div
              v-if="displayList.length < allDataList.length || hasMoreData"
              class="load-more"
              @click="renderNextBatch"
            >
              <div>展开 <van-icon name="arrow-down"> </van-icon></div>
            </div>
          </div>
          <!-- 无数据时显示 -->
          <div v-else class="no-data">
            <div>暂无数据</div>
          </div>
        </div>
        <!-- 空页面 -->
        <div class="empty-temp" v-else>
          <div><img src="@/assets/image/hedging/emptyData.png" alt="" class="empty-png" /></div>
          <div class="empty-text">您还未设置预警敏感度，设置后接收信号提醒</div>
          <div class="empty-set" @click="gotoYjszUrl()">
            去设置 <van-icon name="arrow" size="12px"> </van-icon>
          </div>
        </div>
      </div>
      <!-- 信号池 -->
      <div v-else>
        <div v-if="stockList.length > 0">
          <!--股票表头 -->
          <div class="table-header-stock">
            <van-row>
              <van-col :span="6">
                <div class="item-text">股票</div>
              </van-col>
              <van-col :span="6">
                <div class="item-text item-text-right">{{ activeInfo == 1 ? '持仓股数' : '' }}</div>
              </van-col>
              <van-col :span="6">
                <div class="item-text item-text-right">最新价</div>
              </van-col>
              <van-col :span="6">
                <div class="item-text item-text-right">涨跌幅</div>
              </van-col>
            </van-row>
          </div>
          <!-- 股票列表 -->
          <div class="table-data-stock">
            <van-row
              v-for="(itemStock, indexStock) in zxgStocks"
              :key="indexStock"
              class="table-item-stock"
              gutter="16"
              @click="gotoStock(itemStock.Obj)"
            >
              <van-col :span="6" >
                <div class="item-stock-name">{{ itemStock.ZhongWenJianCheng }}</div>
                <div class="item-stock-code">{{ cleanStockCode(itemStock.Obj) }}</div>
              </van-col>
              <van-col :span="6">
                <div class="item-pos item-text-right">{{ activeInfo == 1 ? itemStock.pos : '' }}</div>
              </van-col>
              <van-col :span="6">
                <div class="item-pos item-text-right">{{  toFixedNum(itemStock.ZuiXinJia,2,'') }}</div>
              </van-col>
              <van-col :span="6">
                <div
                  class="item-zf item-text-right"
                  :class="{
                    'item-zf-red': itemStock.ZhangFu > 0,
                    'item-zf-green': itemStock.ZhangFu < 0
                  }"
                >
                  {{
                    itemStock.ZhangFu >= 0
                      ? '+' + toFixedNum(itemStock.ZhangFu, 2, '%')
                      : toFixedNum(itemStock.ZhangFu, 2, '%')
                  }}
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
        <!-- 空页面 -->
        <div class="empty-temp" v-else>
          <div><img src="@/assets/image/hedging/emptyData.png" alt="" class="empty-png" /></div>
          <div class="empty-title">您还没有设置{{ activeInfo == 1 ? '持仓股' : '自选股' }}哦</div>
          <div class="empty-desc">
            添加{{ activeInfo == 1 ? '持仓股' : '自选股' }}，及时洞察相关数据
          </div>
          <div class="empty-btn" v-if="activeInfo == 1">
            <van-button
              icon="add"
              color="linear-gradient(to right, #286df7, #5e94ff)"
              class="empty-btn-info"
              @click="gotoCcgUrl()"
            >
              添加
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="showReasonStatus" :show-confirm-button="false" class="show-dialog-reason">
      <div class="dialog-reason">
        <div class="dialog-reason-info">
          <div
            class="dialog-reason-title"
            :class="dialogReasonDesc.type == 1 ? 'colorDown' : 'colorUp'"
          >
            {{ dialogReasonDesc.type == 1 ? 'T0 预警' : 'T0 调回' }}
          </div>
          <div class="dialog-reason-desc">
            您的{{ activeInfo == 1 ? '持仓股' : '自选股' }}【{{ dialogReasonInfo.name }}】于
            {{ formatTimeToStr(dialogReasonDesc.time, true) }}
            {{ dialogReasonDesc.type == 1 ? '触发预警信号，预警卖出价 ' : '重新调回，调回价 '
            }}<span :class="dialogReasonDesc.type == 1 ? 'colorDown' : 'colorUp'"
              >{{ dialogReasonDesc.price }}元</span
            >
            <span v-if="dialogReasonDesc.type == 3"
              >，本次T0收益
              <span :class="judgeColor(dialogReasonInfo.t0Rate)">{{
                toFixedNum(dialogReasonInfo.t0Rate, 2, '%')
              }}</span>
            </span>
          </div>
          <div class="dialog-reason-center">
            <div class="dialog-reason-center-img">
              <div class="dialog-reason-text">
                {{ dialogReasonDesc.type == 1 ? '信号理由：' : '调回类型：' }}
              </div>
              <div class="dialog-reason-but" @click="gotoLink(dialogReasonDesc)">
                查看详情 <van-icon name="arrow" size="14px"></van-icon>
              </div>
              <!-- <img
                src="@/assets/image/hedging/liyou-w.png"
                alt=""
                srcset=""
                class="center-img-info"
              /> -->
            </div>
            <div class="dialog-reason-center-text">{{ dialogReasonDesc.reason }}</div>
            <!-- <div
              class="center-text-btn"
              v-if="dialogReasonDesc.link"
              @click="gotoLink(dialogReasonDesc)"
            >
              查看详情 <van-icon name="arrow" size="14px"></van-icon>
            </div> -->
          </div>
        </div>

        <div class="dialog-reason-btn" @click="showReasonStatus = false">我知道了</div>
      </div>
      <div class="rigth-top-img">
        <img
          src="@/assets/image/hedging/bx.png"
          v-if="dialogReasonDesc.type == 1"
          alt=""
          srcset=""
        />
        <img src="@/assets/image/hedging/zq.png" v-else alt="" srcset="" />
      </div>
    </van-dialog>

    <!-- 扣豆弹窗 -->
    <van-dialog v-model="showPopup" :show-confirm-button="false" class="common-overlay">
      <!-- 解锁失败 -->
      <div class="common-popup">
        <img src="@/assets/image/hedging/join-lose.png" class="join-lose" alt="" />
        <div class="popup-content">
          <div class="title">
            <div>慧豆不足</div>
            <div class="title-icon">
              <img src="@/assets/image/hedging/kd-title.png" alt="" srcset="" />
            </div>
          </div>
          <div class="subtitle">解锁需使用{{ koudounum }}豆</div>
          <div class="account-box">
            <div class="account-box-left">
              <span class="money">
                +{{ popupList.number }}万
                <i class="upper-limit">最高</i>
              </span>
              <span class="dou">豆</span>
            </div>

            <div class="account-box-right">
              <p class="name">{{ popupList.name }}</p>
              <p class="welfare" @click="gotoLink2(popupList.link)" >开户入金</p>
            </div>
          </div>

          <button class="btn" @click="gotoLink2(popupList.link)">
            开户立领{{ popupList.claim }}豆
          </button>
          <div class="more" @click="gotoLink2(popupList.more)">
            发现更多赚豆任务
            <van-icon name="arrow"></van-icon>
          </div>
        </div>
        <div class="common-close-btn" @click="showPopup = false">
          <img src="@/assets/image/hedging/common-close.png" alt="" srcset="" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getHistoryPages, getSignalList, signalUnLock } from '@/api/hedging.js';

import {
  judgeColor,
  toFixedNum,
  formatDateToStr,
  formatTimeToStr,
  cleanStockCode,
  compareVersions
} from '@/utils/format';

// 在组件中
import Dzhyun from '@/utils/dzhyun.min.js';

export default {
  // 组件名称
  name: 'hedgingRecord',
  // 组件参数 接收来自父组件的数据
  props: ['yunToken', 'activeInfo'],
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      active: 0,
      // 发出记录参数
      lastid: '',
      pageSize: 3, // 每页查询数量
      // 出发记录, 敏感度设置
      triggerStatus: 0, // 敏感度设置：1-有，0-无
      // 分页控制变量
      allDataList: [], // 所有数据
      displayList: [], // 当前显示的数据
      currentDisplayIndex: 0, // 当前显示的索引
      hasMoreData: true, // 是否还有更多数据
      // 信号池列表
      stockList: [],
      // WebSocket相关
      dzhyunObj: null,
      zxgStocks: [], // 股票行情数据
      // 查看弹窗的管理状态
      showReasonStatus: false,
      // 弹窗的内容
      dialogReasonInfo: {},
      // 弹窗的副内容
      dialogReasonDesc: {},
      // 扣豆弹窗
      showPopup: false,
      popupList: {},
      koudounum: 0,
      // 版本号
      version: '',
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    // 监听yunToken变化，当有值时初始化WebSocket
    yunToken: {
      handler(newVal) {
        if (newVal && this.stockList.length > 0) {
          this.initWebSocket();
        }
      },
      immediate: true
    },

    // 监听yunToken变化，当有值时初始化WebSocket
    activeInfo: {
      handler(newVal) {
        this.resetInit();
      },
      immediate: true
    },

    // 监听stockList变化，当有数据且yunToken存在时初始化WebSocket
    stockList: {
      handler(newVal) {
        if (newVal && newVal.length > 0 && this.yunToken) {
          this.initWebSocket();
        }
      },
      immediate: true
    }
  },
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    formatDateToStr,
    formatTimeToStr,
    cleanStockCode,
    compareVersions,
    // 重置初始化
    resetInit: function () {
      var _this = this;
      // 格式话条件
      _this.lastid = '';
      _this.triggerStatus = null;
      _this.allDataList = []; // 所有数据
      _this.displayList = []; // 当前显示的数据
      _this.currentDisplayIndex = 0; // 当前显示的索引
      _this.hasMoreData = true; // 是否还有更多数据
      // 信号池列表
      _this.stockList = [];
      // WebSocket相关
      _this.zxgStocks = []; // 股票行情数据
      this.closeWebSocket();

      // 获取发出记录
      this.getHistoryPagesFunc();
      // 获取信号池内容
      this.getSignalListFunc();
    },
    // 获取信号记录T0发出记录
    getHistoryPagesFunc: function () {
      var _this = this;
      var params = {
        lastid: this.lastid,
        size: this.pageSize,
        type: _this.activeInfo == 1 ? 2 : 1 // 1-自选 2-持仓
      };
      getHistoryPages(params).then((res) => {
        // 接口请求成功
        if (res.err == 200) {
          // 判断 status 是否开启了敏感度设置：1-有，0-无
          if (res.data.status == 1) {
            // 开启了敏感度设置
            _this.triggerStatus = 1;
          } else {
            // 未开启敏感度设置
            _this.triggerStatus = 0;
          }

          _this.koudounum = res.data.bean ? res.data.bean : 0;

          // 查询数据 res.data.signals.list
          if (res.data.signals && res.data.signals.list) {
            var dataList = res.data.signals.list;

            // 判断数据长度是否小于3，小于3就不进行分页请求
            if (dataList.length < 3) {
              _this.hasMoreData = false;
              _this.allDataList = dataList;
              _this.displayList = dataList;
            } else {
              // 数据大于等于3条，初始化分页逻辑
              _this.allDataList = dataList;
              _this.lastid = dataList[dataList.length - 1].signals[0].date;
              _this.renderNextBatch();
            }
          }
        } else {
          // 接口请求异常
        }
      });
    },
    // 渲染下一批3条数据
    renderNextBatch: function () {
      var _this = this;
      var startIndex = _this.currentDisplayIndex;
      var endIndex = Math.min(startIndex + 3, _this.allDataList.length);

      // 添加新的3条数据到显示列表
      var newBatch = _this.allDataList.slice(startIndex, endIndex);
      _this.displayList = _this.displayList.concat(newBatch);
      _this.currentDisplayIndex = endIndex;

      // 检查是否需要预加载更多数据（但不渲染）
      var remainingData = _this.allDataList.length - _this.currentDisplayIndex;
      if (remainingData < 3 && _this.hasMoreData) {
        // 剩余数据不足3条，预加载下一页数据但不渲染
        _this.preloadMoreData();
      }
    },
    // 预加载更多数据（不渲染）
    preloadMoreData: function () {
      var _this = this;
      var params = {
        lastid: _this.lastid,
        size: _this.pageSize,
        type: _this.activeInfo == 1 ? 2 : 1
      };

      getHistoryPages(params).then((res) => {
        if (res.err == 200 && res.data.signals && res.data.signals.list) {
          var newData = res.data.signals.list;
          if (newData.length > 0) {
            // 将新数据添加到所有数据列表，但不渲染
            _this.allDataList = _this.allDataList.concat(newData);
            _this.lastid = newData[newData.length - 1].signals[0].date;
          } else {
            // 没有更多数据了
            _this.hasMoreData = false;
          }
        } else {
          _this.hasMoreData = false;
        }
      });
    },
    // 加载更多数据
    loadMoreData: function () {
      var _this = this;
      var params = {
        lastid: _this.lastid,
        size: _this.pageSize,
        type: 1
      };

      getHistoryPages(params).then((res) => {
        if (res.err == 200 && res.data.signals && res.data.signals.list) {
          var newData = res.data.signals.list;
          if (newData.length > 0) {
            // 将新数据添加到所有数据列表
            _this.allDataList = _this.allDataList.concat(newData);
            _this.lastid = newData[newData.length - 1].signals[0].date;
            // 继续渲染剩余的数据
            _this.renderNextBatch();
          } else {
            // 没有更多数据了
            _this.hasMoreData = false;
          }
        } else {
          _this.hasMoreData = false;
        }
      });
    },
    // 获取信号池内容
    getSignalListFunc: function () {
      var _this = this;
      var params = {
        type: _this.activeInfo == 1 ? 2 : 1
      };
      getSignalList(params)
        .then((result) => {
          console.log('result', result);
          if (result.err == 200) {
            // 获取成功
            _this.stockList = result.data.list;
          } else {
            // 获取失败
          }
        })
        .catch((err) => {});
    },
    // 初始化接入websocket
    initWebSocket: function () {
      var _this = this;
      // 如果已经存在连接，先关闭
      if (_this.dzhyunObj) {
        _this.closeWebSocket();
      }
      // 确保yunToken存在
      if (!_this.yunToken) {
        console.warn('yunToken is not available, cannot initialize WebSocket');
        return;
      }
      _this.dzhyunObj = new Dzhyun({
        address: window.cloud.WSUrl,
        dataType: 'json',
        token: _this.yunToken
      });
      _this.subscribe();
    },
    // 订阅股票信息
    subscribe: function () {
      var _this = this;
      // 获取股票代码
      if (!_this.stockList || _this.stockList.length === 0) {
        return;
      }
      var codes = _this.stockList.map((item) => item.code).join(',');
      _this.dzhyunObj.cancel();
      var indexsParams = {
        obj: codes,
        field: 'ZhongWenJianCheng,ZuiXinJia,ZhangFu'
      };
      this.dzhyunObj.subscribe('/quote/stkdata', indexsParams, function (data) {
        if (data.length == _this.stockList.length) {
          _this.initStocks(data);
        } else {
          _this.updataStocks(data);
        }
      });
    },
    // 初始化股票
    initStocks: function (data) {
      var _this = this;
      const arr1 = _this.stockList;
      const arr2 = data;

      // 先把 arr1 转成一个以 code 为 key，hidden 为 value 的 Map
      const hiddenMap = {};
      const posMap = {};
      arr1.forEach((item) => {
        hiddenMap[item.code] = item.hidden;
        posMap[item.code] = item.pos ? item.pos : 0;
      });

      // 遍历 arr2，根据 Obj 找对应的 hidden 值
      _this.zxgStocks = arr2.map((item) => {
        return {
          ...item,
          hidden: hiddenMap[item.Obj] !== undefined ? hiddenMap[item.Obj] : null,
          pos: posMap[item.Obj] !== undefined ? posMap[item.Obj] : null
        };
      });
    },
    // 更新股票信息
    updataStocks: function (data) {
      var _this = this;
      data.forEach((updateItem) => {
        const target = _this.zxgStocks.find((item) => item.Obj === updateItem.Obj);
        if (target) {
          target.ZuiXinJia = updateItem.ZuiXinJia;
          target.ZhangFu = updateItem.ZhangFu;
        }
      });
    },
    // 关闭websocket
    closeWebSocket: function () {
      if (this.dzhyunObj !== null) {
        this.dzhyunObj.cancel();
        this.dzhyunObj = null;
      }
    },
    // 点击跳转到事件
    gotoLink: function (item) {
      // 查询item.link 是否存在B$替换成BI
      if (item.link.includes('B$')) {
        item.link = item.link.replace('B$', 'BI');
      }
      window.location.href = item.link;
    },
    // 跳转去购买链接
    gotoShopUrl: function (item, index) {
      var _this = this;
      // 打开扣豆弹窗
      _this.$dialog
        .confirm({
          message: '本次解锁需要花费' + _this.koudounum + '豆,是否继续解锁',
          confirmButtonText: '继续解锁',
          confirmButtonColor: '#3b85fe',
          cancelButtonText: '取消',
          cancelButtonColor: '#aab9d1'
        })
        .then(() => {
          // on confirm
          // 请求扣豆逻辑
          var params = {
            stockCode: item.code,
            sid: item.id
          };
          signalUnLock(params)
            .then((result) => {
              if (result.err == 200) {
                // 成功
                this.$toast('解锁成功');
                _this.displayList[index].hidden = 0;
              } else if (result.err == 302) {
                // 慧豆不足
                _this.showDialogInfo();
              } else {
                // 异常
                this.$toast('解锁异常');
              }
            })
            .catch((err) => {
              this.$toast('解锁异常');
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转到股票分时
    gotoStock: function (stockCode) {
      window.location.href = `dzh_browser_url&goto=0&type=2970&code=${stockCode}&kind=1&source=1&direct=1`;
    },
    // 跳转去预警设置
    gotoYjszUrl: function () {
      window.location.href = window.yjszurl;
    },
    getMobileOSType: function () {
      const ua = navigator.userAgent || navigator.vendor || window.opera;

      console.log('ua', ua);

      const isIOS = /iPhone|iPad|iPod/i.test(ua);
      const isAndroid = /Android/i.test(ua);
      const isHarmony = /dzhhmtablet ohos|ohos|dzhapp ohos|dzhhm2in1 ohos/i.test(ua);

      if (isHarmony) return 4; // 移动鸿蒙终端
      if (isIOS) return 2; // 移动 iOS 终端
      if (isAndroid) return 3; // 移动 Android 终端

      return 1; // pc
    },
    // 点击跳转到持仓股列表
    gotoCcgUrl: function () {
      window.location.href = window.hedgingccg_url;
    },
    // 点击打开弹窗
    showReason: function (item, value) {
      var _this = this;
      _this.dialogReasonInfo = item;
      _this.dialogReasonDesc = value;
      _this.showReasonStatus = true;
    },
    // 打开弹窗
    showDialogInfo: function () {
      var _this = this;
      var qslist = window.t0DetailQsList;
      // console.log('qslist',qslist)
      // qslist = JSON.parse(qslist);
      // 随机取一个,权重个50%
      var random = Math.random();
      if (random < 0.5) {
        _this.popupList = qslist[0];
      } else {
        _this.popupList = qslist[1];
      }
      _this.showPopup = true;
    },
     // 点击跳转
      gotoLink2: function (url) {
          window.location.href = url;
      },
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    this.version = this.$route.query.version ? this.$route.query.version : '9.0';
  },
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {
  },
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {
    this.closeWebSocket();
  },
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style scoped lang="less">
.hedgingRecord {
  padding: 16px;
  // padding-top: 0px;
  background-color: #fff;

  .record-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    .record-title-left {
      &::before {
        content: '';
        display: inline-block;
        // vertical-align: middle;
        width: 3px;
        height: 10px;
        background-color: #3b85fe;
        border-radius: 88px;
        margin-right: 4px;
      }
      .record-title-left-text {
        font-weight: 600;
        color: #1d2129;
        font-size: 16px;
        margin-right: 4px;
      }
    }
    .record-title-right {
      color: #949da8;
      font-size: 12px;
    }
  }

  .record-tabs {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;

    .van-tabs {
      ::v-deep {
          .van-tabs__line {
          bottom: 22px !important;
        }
      }
    }

    .tabs-info {
      width: 50%;
      .record-tabs-info {
        .van-tab {
          font-size: 16px !important;
        }

      }
    }
    .but-info {
      width: 50%;
      text-align: right;
      .but-info-text {
        color: #286df7;
        background-color: #e9f0fe;
        border: 1px solid #e9f0fe;
        padding: 2px 10px;
      }
    }
  }
  // 内容部分
  .record-content {
    margin-top: 12px;
    // T0 表头样式
    .table-header-t0 {
      .item-text {
        font-size: 12px;
        color: #949da8;
      }
      .item-text-right {
        text-align: right;
      }
    }
    // T0 数据列表样式
    .table-item-t0 {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 6px;
      border-bottom: 1px solid #e5e6eb;
      // 股票名称
      .item-t0-stock-name {
        color: #1d2129;
        font-size: 15px;
      }
      // 涨幅
      .item-t0-stock-zf {
        font-size: 15px;
        font-weight: 500;
      }
      // 右侧内容
      .item-t0-right {
        position: relative;
        .item-t0-list {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          margin-bottom: 10px;
          .item-t0-list-item {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
            // 时间日期
            .item-t0-time {
              color: #949da8;
              font-size: 12px;
              .item-t0-yjtag {
                background: #e8ffec;
                border-radius: 2px;
                color: #1eac4e;
                font-size: 10px;
                border-radius: 2px;
                padding: 0 4px;
                margin-left: 4px;
              }
              .item-t0-httag {
                background: #ffece8;
                border-radius: 2px;
                color: #ef3939;
                font-size: 10px;
                border-radius: 2px;
                padding: 0 4px;
                margin-left: 4px;
              }
            }
            // 文案
            .item-t0-desc {
              flex: 1;
              // 溢出隐藏显示...
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #4e5969;
              font-size: 12px;
            }
            .item-t0-view {
              width: 40px;
              color: #949da8;
              font-size: 11px;
              text-align: right;
            }
          }
        }
        // 解锁按钮 : 定位在中间
        .item-t0-unlock {
          width: 100px;
          height: 25px;
          border: 1px solid #286df7;
          border-radius: 88px;
          line-height: 24px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          color: #286df7;
          font-size: 12px;
        }
      }
    }
    .table-item-t0:last-child {
      border-bottom: none;
    }
    // 数据列表样式
    .data-list {
      .data-item {
        padding: 12px;
        margin-bottom: 8px;
        background-color: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;

        .item-content {
          .item-title {
            font-size: 14px;
            font-weight: 500;
            color: #1d2129;
            margin-bottom: 4px;
          }
          .item-desc {
            font-size: 12px;
            color: #86909c;
          }
        }
      }

      .load-more {
        text-align: center;
        margin-top: 16px;
        color: #949da8;
        font-size: 12px;
      }
    }

    // 自选股表头
    .table-header-stock {
      color: #86909c;
      font-size: 12px;
      .item-text-right {
        text-align: right;
      }
    }
    // 自选股数据
    .table-data-stock {
      .table-item-stock {
        padding: 6px 0;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: flex-start;
        align-items: center;
        .item-stock-name {
          font-weight: 500;
          color: #1d2129;
          font-size: 15px;
        }
        .item-stock-code {
          color: #949da8;
          font-size: 13px;
        }
      }
      .item-text-right {
        text-align: right;
      }
      .item-pos {
        font-size: 17px;
        color: #1d2129;
        font-weight: 500;
        font-family: 'dzh';
      }
      .item-zf {
        background: #8e9ab7;
        border-radius: 4px;
        font-weight: 500;
        color: #ffffff;
        font-size: 15px;
        min-width: 80px;
        height: 23px;
        text-align: center;
        line-height: 22px;
      }
      .item-zf-red {
        background: #f24957;
      }
      .item-zf-green {
        background: #12a876;
      }
    }

    .no-data {
      text-align: center;
      padding: 40px 0;
      color: #86909c;
      font-size: 14px;
    }

    // 空数据
    .empty-temp {
      width: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: center;
      .empty-png {
        width: 72px;
        height: 61px;
        margin: 7px auto;
      }
      .empty-text {
        color: #4e5969;
        font-size: 13px;
        margin-bottom: 14px;
      }
      .empty-set {
        color: #286df7;
        font-size: 15px;
      }
      .empty-title {
        color: #1d2129;
        font-size: 15px;
        margin-bottom: 8px;
      }
      .empty-desc {
        color: #8a929c;
        font-size: 12px;
        margin-bottom: 12px;
      }
      .empty-btn {
        .empty-btn-info {
          width: 208px;
          height: 37px;
          border-radius: 88px;
        }
      }
    }
  }

  // 弹窗
  .show-dialog-reason {
    .rigth-top-img {
      position: absolute;
      top: 0;
      right: 0;
      width: 60px;
      height: 60px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .dialog-reason {
    padding-top: 18px;
    .dialog-reason-info {
      padding: 0 20px;
    }
    .dialog-reason-title {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
    }
    .dialog-reason-desc {
      margin: 10px auto;
      color: #1d2129;
      font-size: 16px;
      line-height: 26px;
    }
    .dialog-reason-center {
      padding: 15px 10px;
      background-color: #f7f7f7;
      border-radius: 10px;
      .dialog-reason-center-img {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;
        .dialog-reason-text {
          font-weight: 900;
          color: #4e5969;
          font-size: 16px;
        }
        .dialog-reason-but {
          color: #7ea7fa;
          font-size: 12px;
        }
        // width: 70px;
        // height: 15px;
        // margin-bottom: 10px;
        // .center-img-info {
        //   display: block;
        //   width: 100%;
        //   height: 100%;
        // }
      }
      .dialog-reason-center-text {
        color: #4e5969;
        font-size: 14px;
        // 展示三行移除显示...
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .center-text-btn {
        color: #7ea7fa;
        font-size: 14px;
        text-align: right;
      }
    }

    .colorUp {
      color: #ef3939;
    }
    .colorDown {
      color: #1eac4e;
    }
    .dialog-reason-btn {
      padding: 16px 0;
      border-top: 1px solid #e7e7e7;
      text-align: center;
      margin-top: 18px;
      font-weight: 600;
      color: #286df7;
      font-size: 16px;
    }
  }
}

// 扣豆弹窗
.common-overlay {
  overflow: visible;
  .common-popup {
    padding: 19px 30px;
    .join-lose {
      position: absolute;
      top: -75px;
      left: 50%;
      transform: translateX(-50%);
      width: 185px;
      height: 121px;
    }
    // 弹窗内容
    .popup-content {
      .title {
        font-size: 22px;
        font-weight: bold;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        .title-icon {
          width: 90px;
          height: 18px;
          img {
            width: 100%;
            height: 100%;
            display: block;
            margin-top: -10px;
          }
        }
      }
      .subtitle {
        text-align: center;
        margin-top: 4px;
        color: #4e5969;
        font-size: 15px;
      }
      .account-box {
        background: linear-gradient(90deg, #fffad8 0%, #eaf4fb 100%);
        border-radius: 10px;
        margin-top: 13px;
        padding: 15px 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .account-box-left {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          width: 55%;
          border-right: 1px dashed rgba(0, 0, 0, 0.2);
          .money {
            font-weight: 700;
            color: #ff6c09;
            font-size: 30px;
            position: relative;
          }
          .dou {
            font-weight: 700;
            color: #ff6c09;
            font-size: 14px;
          }
          .upper-limit {
            font-weight: 500;
            color: #c87200;
            font-size: 10px;
            position: absolute;
            width: 32px;
            height: 14px;
            line-height: 14px;
            text-align: center;
            background: #ffef79;
            border: 1px solid;
            border-color: #ffffff;
            border-radius: 6px 6px 6px 0px;
            top: -12px;
            right: -37px;
          }
        }
        .account-box-right {
          width: 45%;
          text-align: left;
          padding-left: 20px;
          .name {
            font-weight: 500;
            color: #1d2129;
            font-size: 16px;
          }
          .welfare {
            color: #286df7;
            font-size: 13px;
            margin-top: 5px;
          }
        }
      }
      .btn {
        width: 100%;
        height: 42px;
        background: #286df7;
        border-radius: 100px;
        color: #ffffff;
        font-size: 16px;
        margin-top: 16px;
      }
      .more {
        margin-top: 12px;
        color: #1d2129;
        font-size: 14px;
        text-align: center;
      }
    }
    // 关闭按钮
    .common-close-btn {
      position: absolute;
      bottom: -60px;
      left: 50%;
      transform: translateX(-50%);
      width: 33px;
      height: 33px;
    }
  }
}

.black_theme {
  .hedgingRecord {
    background-color: #181a23;
    .record-title {
      .record-title-left {
        .record-title-left-text {
          color: #e4e9fe;
        }
      }
      .record-title-right {
        color: #6b7687;
      }
    }


    .but-info {
      .but-info-text {
        color: #3b85fe;
        background-color: #272935;
        border: 1px solid #272935;
      }
    }

    // 内容部分
    .record-content {
      // T0 表头样式
      .table-header-t0 {
        .item-text {
          color: #6b7687;
        }
      }
      // T0 数据列表样式
      .table-item-t0 {
        border-bottom: 1px solid #0e1115;
        // 股票名称
        .item-t0-stock-name {
          color: #e4e9fe;
        }
        // 右侧内容
        .item-t0-right {
          .item-t0-list {
            .item-t0-list-item {
              // 时间日期
              .item-t0-time {
                color: #6b7687;
                .item-t0-yjtag {
                  background: #17341c;
                  color: #1eac4e;
                }
                .item-t0-httag {
                  background: #3b2520;
                  color: #ef3939;
                }

              }
              // 价格
               .item-t0-price {
                  color: #e4e9fe;
                }
              // 文案
              .item-t0-desc {
                color: #aab9d1;
              }
              .item-t0-view {
                color: #6b7687;
              }
            }
          }
          // 解锁按钮 : 定位在中间
          .item-t0-unlock {
            border: 1px solid #254b89;
            color: #3b85fe;
          }
        }
      }
      // 数据列表样式
      .data-list {
        .data-item {
          background-color: #f8f9fa;
          border: 1px solid #e9ecef;

          .item-content {
            .item-title {
              font-size: 14px;
              font-weight: 500;
              color: #1d2129;
              margin-bottom: 4px;
            }
            .item-desc {
              font-size: 12px;
              color: #86909c;
            }
          }
        }

        .load-more {
          text-align: center;
          margin-top: 16px;
          color: #949da8;
          font-size: 12px;
        }
      }

      // 自选股表头
      .table-header-stock {
        color: #6b7687;
      }
      // 自选股数据
      .table-data-stock {
        .table-item-stock {
          .item-stock-name {
            color: #e4e9fe;
          }
          .item-stock-code {
            color: #6b7687;
          }
        }
        .item-pos {
          color: #e4e9fe;
        }
        .item-zf {
          background: #5c6885;
        }
        .item-zf-red {
          background: #e53d44;
        }
        .item-zf-green {
          background: #009255;
        }
      }

      .no-data {
        text-align: center;
        padding: 40px 0;
        color: #86909c;
        font-size: 14px;
      }

      // 空数据
      .empty-temp {
        .empty-text {
          color: #aab9d1;
        }
        .empty-set {
          color: #3b85fe;
        }
        .empty-title {
          color: #e4e9fe;
        }
        .empty-desc {
          color: #aab9d1;
        }
      }
    }
  }

  // 弹窗
  .show-dialog-reason {
    background-color: #1d202d;
  }
  .dialog-reason {
    background-color: #1d202d;
    .dialog-reason-desc {
      color: #e4e9fe;
    }
    .dialog-reason-center {
      background-color: #272935;
      .dialog-reason-center-img {
        .dialog-reason-text {
          color: #aab9d1;
        }
      }
      .dialog-reason-center-text {
        color: #aab9d1;
      }
      .center-text-btn {
        color: #7ea7fa;
      }
    }

    .colorUp {
      color: #ef3939;
    }
    .colorDown {
      color: #1eac4e;
    }
    .dialog-reason-btn {
      border-top: 1px solid #0b0f12;
      color: #3b85fe;
    }
  }


// 扣豆弹窗
.common-overlay {
  .common-popup {
    // 弹窗内容
    .popup-content {
      .title {
        color: #ffffff;
      }
      .subtitle {
        color: #aab9d1;
      }
      .account-box {
        background: linear-gradient(89.9deg, #353326 0.02%, #2c3848 99.98%);
        .account-box-left {
         border-right: 1px dashed rgba(225, 225, 225, 0.2);
          .money {
            color: #ffef79;
          }
          .dou {
            color: #ffef79;
          }

        }
        .account-box-right {
          .name {
            color: #ffffff;
          }
          .welfare {
             color: #74a9ff;
          }
        }
      }
      .btn {
        background: #3b85fe;
      }
      .more {
        color: #e4e9fe;
      }
    }

  }
}

}
</style>
